import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return (
    <div className="min-h-screen flex items-center justify-center text-stone-500">Carregando…</div>
  );
  if (!user) return <Navigate to="/auth/login" replace />;
  return children;
}
